import React, { Component } from 'react';
import {Row, Col, ToggleButtonGroup, ToggleButton} from 'react-bootstrap';
import {TimeseriesChart, createPlotlyDataArray, getTitle } from './Charts/TimeseriesChart';
import Plotly from 'plotly.js-basic-dist';
import createPlotlyComponent from 'react-plotly.js/factory';
import {createDateArray, filterNulls} from "../util/timeseries";
import {lineColors} from "./styles";
import moment from 'moment';
const Plot = createPlotlyComponent(Plotly);

class ChartPicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleChange = this.handleChange.bind(this);

        this.state = {
            value: [0]
        };
    }

    handleChange(e) {
        this.setState({ value: e });
        this.props.changed(e);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (JSON.stringify(nextProps) !== JSON.stringify(this.props)) ||
            (JSON.stringify(this.state) !== JSON.stringify(nextState));
    }

    render() {
        const buttons = [];
        
        for (let index = 0; index < this.props.items.length; index++) {
            const title = this.props.items[index];
            const button = <ToggleButton key={index} value={index}>{title}</ToggleButton>;
            buttons.push(button);
        }
        return (
            <ToggleButtonGroup
                type="radio"
                name="options"
                value={this.state.value}
                onChange={this.handleChange}
            >
                {buttons}
            </ToggleButtonGroup>
        );
    }
}


export class ForecastLineChart extends Component {
    constructor(p) {
        super(p);
        this.state = { };
        this.createPlotlyDataArray1 = this.createPlotlyDataArray1.bind(this);
        this.createPercentilePlot = this.createPercentilePlot.bind(this);
    }

    createPlotlyDataArray1(series, endDate, numberOfItems) {
        let plotlyArray = [];
        if (!series) {
            return plotlyArray;
        }
        
        // subset array:
        let endIndex = Math.round(moment.duration(moment(endDate).diff(moment(series.startDate))).asMonths());
        let startIndex = endIndex - 12;
        
        let s = { startDate: moment(endDate).subtract(12, 'months')};
        let newValues = [];
        for (let i = startIndex; i < endIndex; i++) {
            newValues.push(series.values[i]);
        }
        s.values = newValues;
        s.timeStep = 'Monthly';

        // create a date array that can be shared with all series
        // since they all have the same length
        var dates = createDateArray(s);

            let color = lineColors[0 % lineColors.length];
            let data = filterNulls(s.values);

            var plotlyObj = {
                x: dates,
                y: data,
                type: 'scatter',
                name: series.name,
                color: color,
                line : {
                    color: color
                }
            };

            plotlyArray.push(plotlyObj);

        return plotlyArray;
    }
    
    createPercentilePlot(data, value, title, index, date) {
        let firstVal = data[0].y[data[0].y.length - 1];
        let firstDate = moment(date).subtract(1, 'months').format("MMM YYYY");
        let lastDate = moment(date).format("MMM YYYY");
        let color = lineColors[index % lineColors.length];
        var plotlyObj = {
            x: [firstDate, lastDate],
            y: [firstVal, value],
            type: 'scatter',
            name: title, 
            color: color,
            line : {
                color: color
            }
        }; 
        
        return plotlyObj;
    }
    
    render() {
        let data = [];

        let yAxisTitle = '';
        if (this.props && this.props.series && this.props.forecastData) {
            let date = this.props.forecastData.date;
            data = this.createPlotlyDataArray1(this.props.series,  date,12);
            yAxisTitle = 'Flow (MCM)';
            let p5 = this.createPercentilePlot(data, this.props.forecastData.p5, '5% Percentile',1, date);
            let p25 = this.createPercentilePlot(data, this.props.forecastData.p25, '25% Percentile',2, date);
            let p50 = this.createPercentilePlot(data, this.props.forecastData.p50, 'Median', 3, date);
            let p75 = this.createPercentilePlot(data, this.props.forecastData.p75, '75% Percentile', 2, date);
            let p95 = this.createPercentilePlot(data, this.props.forecastData.p95, '95% Percentile', 1, date);

            data.push(p5);
            data.push(p25);
            data.push(p50);
            data.push(p75);
            data.push(p95);
        }

        const layout = {
            title: this.props.title,
            autosize: true,
            legend: {
                orientation:"h",
                x:0.37,
                y:-0.3
            },
            margin: {
                l:50,
                r:10,
                t:10,
                b:0,
                pad: 0
            },
            yaxis: {
                title: yAxisTitle,
            }
        };
        
        const style = {
            width: "100%",
            height: "100%",
        };
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h3>Forecast Flows</h3>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
            <Plot data={data} layout={layout} useResizeHandler={true} style={style} config={{displaylogo: false, modeBarButtonsToRemove:['sendDataToCloud'], responsive:true}}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

function ForecastChart(props) {
    return <Plot></Plot>;
}

export class LineChartPicker extends Component {
    constructor(p) { 
        super(p);
        this.state = { selection: 0};
        this.selectedSeriesChanged = this.selectedSeriesChanged.bind(this);
    }

    shouldComponentUpdate (nextProps, nextState) {
        // only re-render if the props (i.e. data) has changed
        // we need this since the render method can be a bit heavy/slow
        return (JSON.stringify(nextProps) !== JSON.stringify(this.props)) ||
            (JSON.stringify(this.state) !== JSON.stringify(nextState));
    }
    
    selectedSeriesChanged(e) {
        this.setState({selection: e });
    }

    render() {
        let items = [];
        
        let series = [];
        if (this.props.series && this.state.selection !== undefined)  {
            for (let i = 0; i < this.props.series.length; i++) {
                items.push(this.props.series[i].name);
            }
            series.push(this.props.series[this.state.selection]);
        }
        
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h3>{this.props.title}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <ChartPicker items={items} changed={this.selectedSeriesChanged} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <TimeseriesChart series={series} margins={{l:50, r: 5, t: 80, b:70}}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

export class LineChart extends Component {
    shouldComponentUpdate (nextProps, nextState) {
        // only re-render if the props (i.e. data) has changed
        // we need this since the render method can be a bit heavy/slow
        return (JSON.stringify(nextProps) !== JSON.stringify(this.props));
    }
    
    render() {
        return (
            <div>
                        <TimeseriesChart series={this.props.series} title={this.props.title} margins={{l:40, r: 5, t: 80, b:0}} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LineChart.jsx